import React from "react";

const Footer = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400&family=Playfair+Display:wght@600&display=swap');

        .footer {
          background: linear-gradient(180deg, #2c1a00, #1a0f00);
          border-top: 1px solid rgba(196,138,20,0.2);
          padding: 28px 24px;
          text-align: center;
        }

        .footer-name {
          font-family: 'Playfair Display', serif;
          font-size: 15px;
          color: #f0c060;
          margin-bottom: 6px;
        }

        .footer-copy {
          font-family: 'Lato', sans-serif;
          font-size: 13px;
          color: rgba(253,248,240,0.4);
          letter-spacing: 0.3px;
        }

        .footer-divider {
          color: rgba(196,138,20,0.4);
          margin: 0 8px;
        }
      `}</style>

      <footer className="footer">
        <div className="footer-name">Acharya Tarun Kumar Sah</div>
        <div className="footer-copy">
          Copyright © {new Date().getFullYear()}
          <span className="footer-divider">✦</span>
          All Rights Reserved
        </div>
      </footer>
    </>
  );
};

export default Footer;